import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { UserStateModel } from './user-state.models';
import { UserStateActions } from './user-state.actions';

const STATE_NAME = 'UserState';

@State<UserStateModel>({
  name: STATE_NAME,
  defaults: {
    isLoggedIn: false,
    access_token: null,
    refresh_token: null,
  },
})
@Injectable()
export class UserState {
  @Selector()
  static user(state: UserStateModel): UserStateModel | null {
    return state;
  }

  @Selector()
  static accessToken(state: UserStateModel): string | null {
    return state.access_token;
  }

  @Selector()
  static refreshToken(state: UserStateModel): string | null {
    return state.refresh_token;
  }

  @Selector()
  static isLoggedIn(state: UserStateModel): boolean {
    return state.isLoggedIn;
  }

  @Action(UserStateActions.SetIsLoggedIn)
  setIsLoggedIn(ctx: StateContext<UserStateModel>, action: UserStateActions.SetIsLoggedIn) {
    ctx.patchState(<UserStateModel>({
      isLoggedIn: action.isLoggedIn,
    }));
  }

  @Action(UserStateActions.SetAuthToken)
  setAuthToken(ctx: StateContext<UserStateModel>, action: UserStateActions.SetAuthToken) {
    ctx.patchState(<UserStateModel>({
      access_token: action.authToken,
    }));
  }

  @Action(UserStateActions.SetRefreshToken)
  setRefreshToken(ctx: StateContext<UserStateModel>, action: UserStateActions.SetRefreshToken) {
    ctx.patchState(<UserStateModel>({
      refresh_token: action.refreshToken,
    }));
  }

  @Action(UserStateActions.DeleteTokens)
  deleteTokens(ctx: StateContext<UserStateModel>) {
    ctx.patchState(<UserStateModel>({
      isLoggedIn: false,
      refresh_token: null,
      access_token: null
    }));
  }

  @Action(UserStateActions.DeleteUser)
  deleteUser(ctx: StateContext<UserStateModel>) {
    ctx.patchState(<UserStateModel>({
      isLoggedIn: false,
      refresh_token: null,
      access_token: null
    }));
  }
}

